import { StyleSheet, View } from 'react-native';

import { tokens } from '@fhs/ui';

import { AppHeader } from './app-header';
import { MenuLocationButton } from './menu-location-button';

export function MenuWebHeader() {
  return (
    <>
      <AppHeader />
      <View style={styles.location}>
        <MenuLocationButton />
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  location: {
    backgroundColor: tokens.colors.$white,
    alignItems: 'center',
    padding: 16,
  },
});
